export const DASHBOARD_SUMMARY = /* GraphQL */ `
  query DashboardSummary {
    dashboardSummary {
      totalKeywords
      totalChannels
      totalContents
      avgEnhancedScore
      activeKeywords
      recentSearches
    }
  }
`;

export const DASHBOARD_WEEKLY_TREND = /* GraphQL */ `
  query DashboardWeeklyTrend {
    dashboardWeeklyTrend {
      weekStart
      keywordCount
      channelCount
      contentCount
    }
  }
`;

export const DASHBOARD_DOMAIN_USAGE = /* GraphQL */ `
  query DashboardDomainUsage {
    dashboardDomainUsage {
      domain
      count
    }
  }
`;

export const DASHBOARD_SPARKLINES = /* GraphQL */ `
  query DashboardSparklines {
    dashboardSparklines {
      label
      values
    }
  }
`;

export const DASHBOARD_ACTIVITY = /* GraphQL */ `
  query DashboardActivity {
    dashboardActivity {
      action
      detail
      time
      iconKey
    }
  }
`;
